








































import { Vue } from "@/types.ts";

export default Vue.extend({
  components: {},
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {};
  },
  methods: {
    logout(): void {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    setLocale(locale: string) {
      this.$root.$emit("setLocale", locale);
    },
  },
  name: "App",
});
